module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "Home-Apply-O2.7c03a538.webp" + "?" + Date.now();